export default __webpack_public_path__ + "static/media/avatar_148.f3377544.png";